import React from "react";
import "./OurMaster.css";

const OurMaster = () => {
  return (
    <div className="master">
      <div className="section-header">
        <h2 className="section-heading animated" data-animation="bounceInUp">
          Our Master
        </h2>
        <h3>Master Suresh S Rao</h3>
        <div className="master_img">
          <img src="images/master.jpg" width="320" alt="Master Suresh S Rao" />
        </div>
        <p>
          With over <strong>45 years of unparalleled expertise</strong>, our master stands as a beacon of excellence in the martial arts world. His illustrious journey is marked by remarkable accomplishments, including:
        </p>
        <ul className="achievements">
          <li>Karnataka State Open Champion (1984-1990)</li>
          <li>National Champion (AIKF) (1990-1994)</li>
          <li>All India National Black Belt Champion (1994-1997)</li>
          <li>Selected by the Government of India for International Competitions (1997)</li>
        </ul>
        <h4>Skills and Disciplines</h4>
        <p>
          Our master’s diverse skill set showcases his dedication to physical and mental mastery, encompassing:
        </p>
        <ul className="skills">
          <li>Maramakala</li>
          <li>Kickboxing</li>
          <li>Wrestling</li>
          <li>Yoga</li>
        </ul>
        <p>
          <strong>Experience the legacy of a true martial arts virtuoso.</strong>
        </p>
      </div>
    </div>
  );
};

export default OurMaster;